module.exports = __webpack_public_path__ + "media/images/emblems/Saulcy_Blazono-bedaa307becbb931ff4b0038518ba2dd.png";